module.exports = __webpack_public_path__ + "static/media/services_icon.201b78c3.svg";